import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'
import type { SearchStoreState } from '../types'

export const updateDepartmentCounts = ({
  currentState,
  newState,
  newDepartment,
}: {
  currentState: SearchStoreState
  newState: Partial<SearchStoreState>
  newDepartment?: DepartmentsEnum
}) => {
  const prevDepartmentCounts =
    currentState.searchContext?.departmentCounts?.filter(
      d => d.department !== newDepartment,
    ) || /* istanbul ignore next */ []

  const newDepartmentCounts =
    newState.searchContext?.departmentCounts?.filter(
      d => d.department === newDepartment,
    ) || /* istanbul ignore next */ []

  return [...prevDepartmentCounts, ...newDepartmentCounts]
}
